import { useTranslation } from 'react-i18next'

const SECTIONS = [
  'collect', 'notCollected', 'use', 'audio', 'thirdParty',
  'security', 'retention', 'deletion', 'rights', 'cookies',
  'children', 'international', 'chromeWebStore', 'changes', 'contact',
] as const

export default function PrivacyPage() {
  const { t } = useTranslation()

  return (
    <div className="max-w-[740px] mx-auto px-6 pt-12 pb-24">
      <div className="glass-panel rounded-2xl p-8 md:p-12">
        <h1 className="text-[1.8rem] font-extrabold mb-2">{t('legal.privacy.title')}</h1>
        <p className="text-[0.85rem] text-text-muted mb-10">{t('legal.effectiveDate')}</p>

        <div className="flex flex-col gap-8">
          {SECTIONS.map((key) => (
            <section key={key}>
              <h2 className="text-[1.05rem] font-bold mb-2">{t(`legal.privacy.${key}.title`)}</h2>
              <p className="text-[0.9rem] text-text-muted leading-relaxed">{t(`legal.privacy.${key}.body`)}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  )
}
